<template>
  <div>

    <v-row v-if="isLoading">
      <v-col v-for="item in 4" :key="item" cols="3">
        <v-card class="rounded-lg shadow">
          <v-card-text>
            <v-skeleton-loader type="list-item-avatar-three-line"></v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-else>

      <v-col v-for="(widget,i) in widgets" :key="i" cols="12" lg="3">

        <v-card class="rounded-lg shadow">
          <v-card-text class="py-5">
            <v-row align="center" justify="center">
              <v-col cols="2">
                <v-avatar :color="widget.color" size="38" class="rounded-lg">
                  <v-icon color="white">{{ widget.icon }}</v-icon>
                </v-avatar>
              </v-col>
              <v-col cols="10">
             <div class="ml-3 text-no-wrap">
               <div class="font-weight-black title pb-1 grey--text text--darken-3">
                 {{ widget.count }}
               </div>
               {{ widget.title }}
             </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>

  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  props: ['opus_campaign_id'],
  data() {
    return {
      isLoading: false,
      widgets: [],
    }
  },
  methods: {
    getWidgets() {
      this.isLoading = true
      if (!this.opus_campaign_id) return;
      HTTP.get('/v1/opus/dashboard/widgets', {
        params: {
          opus_campaign_id: this.opus_campaign_id
        }
      }).then(res => {
        this.isLoading = false
        this.widgets = res.data.data

      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
  },
  created() {
    this.getWidgets()
  },
  watch: {
    opus_campaign_id(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getWidgets();
      }
    }
  }

}
</script>

<style scoped>

</style>